import { defineComponent as _defineComponent } from 'vue'
import { useForm } from '@/util/useForm';
import { ref, watch } from 'vue';
import { PointsProduct } from '../../type/points';
import { formatDate } from '@/util/global';
import {
  exchangeGiftCouponCode,
  getGiftCouponCode,
  GiftCouponCode,
} from '@/api/marketing/giftCoupon';
import { useRoute,useRouter } from '../../../../router/index';
import PasswordLine from '@/component/PasswordLine/PasswordLine.vue';
import ModalItem from '@/component/ModalItem/ModalItem.vue';
import { setRegion } from '@/view/repository/region';
import storage from 'baimahu/storage';
import JsonExcel from 'vue-json-excel';
import moment from 'moment';
import { getPermission } from '@/pinia/modules/permission';


export default /*#__PURE__*/_defineComponent({
  __name: 'GiftCouponList',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const permission = getPermission('marketing/gift-coupon');

const tableloading = ref<boolean>(false);
const total = ref(0);
const queryParams = ref<any>({});
async function query(params = queryParams.value) {
  tableloading.value = true;
  const res = await getGiftCouponCode({
    ...params,
    date: undefined,
    giftcoupon_id: route.query.giftcoupon_id,
    exchange_start: params?.date?.[0]?.valueOf() || undefined,
    exchange_end: params?.date?.[1]?.valueOf() || undefined,
  });
  tableloading.value = false;
  total.value = res.total;
  dataSource.value = res?.detail || [];
  if (res?.detail) {
    pagination.value = {
      total: res?.total,
      current: res?.current,
      pageSize: res?.limit,
      showTotal: () => `共${res.total}条，每页${res.limit}条`,
    };
  } else {
    dataSource.value = [];
    pagination.value = {
      total: res?.total || 1,
      current: 1,
      pageSize: res?.limit || 10,
      showTotal: () => `共${res?.total || 1}条，每页${res?.limit || 10}条`,
    };
  }
}
//检查查询参数变化请求接口刷新数据
watch(
  queryParams,
  (newVal, oldVal) => {
    query(newVal);
  },
  { immediate: true }
);
const form = useForm();
//表单提交
function submit(e) {
  //移除表单提交默认事件
  e.preventDefault();
  const formdata = form.value.getFormValue();
  queryParams.value = {
    ...queryParams.value,
    current: 1,
    ...formdata,
  };
}
//重置表单
function clearForm() {
  form.value.resetFields();
  queryParams.value = { current: 1 };
}

const dataSource = ref<GiftCouponCode[]>([]);
const pagination = ref<{
  current: number;
  total: number;
  pageSize: number;
  showTotal: () => string;
}>();
function onPagination(page: { current: number; pageSize: number; showTotal: any; total: number }) {
  queryParams.value = {
    ...queryParams.value,
    current: page.current,
  };
}
const modalForm = useForm();
async function artificial(onLoading, callback) {
  modalForm.value.validateFields(async (err, values) => {
    if (!err) {
      onLoading();
      const res = await exchangeGiftCouponCode({
        giftcoupon_code: values?.code,
        giftcoupon_passwd: values?.passwd,
        mobile: values?.mobile,
        address: values?.address,
        province_name: values?.city_value?.[0],
        city_name: values?.city_value?.[1],
        area_name: values?.city_value?.[2],
        express_name: values?.express_name,
      });
      if (res) {
        query();
        callback();
        modalForm.value.resetFields();
      }else{
        modalForm.value.setFields({code:{
          value:values?.code,
          errors:[Error('兑换码无效或者密码错误')]
        }})
        modalForm.value.setFields({passwd:{
          value:values?.passwd,
          errors:[Error('兑换码无效或者密码错误')]
        }})
        onLoading();
      }
    }
  });
}
const province_list = ref<any[]>([]);
async function initProvince_list() {
  await setRegion();
  province_list.value = storage.getItem('region_list');
}
initProvince_list();
const json_fields = {
  序号: 'id',
  券码名称: 'name',
  礼品编码: 'code',
  礼品码: 'passwd',
  生成时间: 'create_time',
  状态: 'status',
  兑换时间: 'exchange_time',
  兑换类型: 'exchange_type',
  有效期: 'end_time',
  买家昵称: 'nickname',
  买家手机号: 'mobile',
  收货人姓名: 'express_name',
  收货人电话: 'express_mobile',
  收货人地址: 'express_address',
};
const filename = ref<string>('');
async function fetchData() {
  const params = queryParams.value;
  const time = moment(new Date()).format('MM-DD HH:mm:ss');
  filename.value = `${time}-${route.query.name}-${total.value}`;
  const res = await getGiftCouponCode({
    ...params,
    is_download: 1,
    date: undefined,
    giftcoupon_id: route.query.giftcoupon_id,
    exchange_start: params?.date?.[0]?.valueOf() || undefined,
    exchange_end: params?.date?.[1]?.valueOf() || undefined,
    limit: total.value,
  });
  return res.detail.map(item => ({
    ...item,
    name: route.query.name,
    create_time: formatDate(item.create_time),
    exchange_time: item.status == 2 ? formatDate(item.exchange_time) : '-',
    end_time: formatDate(item.end_time),
    status: item.status == 1 ? '未兑换' : '已兑换',
    exchange_type: item.exchange_type == 1 ? '线上' : item.exchange_type == 2 ? '人工' : '',
  }));
}
function siteValidator(rule, input, callback){
  if(input?.length<3){
    callback('收件地址必须精确到区')
  }
callback()
}

return { __sfc: true,route, router, permission, tableloading, total, queryParams, query, form, submit, clearForm, dataSource, pagination, onPagination, modalForm, artificial, province_list, initProvince_list, json_fields, filename, fetchData, siteValidator, formatDate, PasswordLine, JsonExcel }
}

})